import db from "@/libs/utils/db";
export default {
    namespaced: true,
    state: {
        keepAlive: [],
        keep:{},
        keepath : "",//当前路由地址
        keepName:"",//当前路由名字
        tabName : ""
    },
    mutations:{
        /**
         * 设备tab名称
         * @param state
         * @param name
         */
        setTabName (state, name) {
            state.tabName = name;
        },
    },
    actions: {



        /**
         * 设置当前keep
         * @param state
         * @param name
         */
        setKeep (state, name) {
            state.state.keep = name;
        },
        /**
         * 设置当前path
         * @param state
         * @param name
         */
        setKeepath (state, name) {
            state.state.keepath = name;
        },

        /**
         * 设置当前path
         * @param state
         * @param name
         */
        setKeepName (state, name) {
            state.state.keepName = name;
        },

        /**
         * @description 增加一个页面的缓存设置
         * @param {Object} state vuex state
         * @param {String} name name
         */
        keepAlivePush (state, name) {
            for(var i in state.state.keepAlive) {
                if(state.state.keepAlive[i] == name) return;
            }
            const keep = [ ...state.state.keepAlive ];
            keep.push(name);
            state.state.keepAlive = keep;
        },
        /**
         * @description 清空页面缓存设置
         * @param {Object} state vuex state
         */
        keepAliveClean (state) {
            state.state.keepAlive = [];
        },

    }
}
